import { render, staticRenderFns } from "./ContactSubContacts.vue?vue&type=template&id=910a54a6"
import script from "./ContactSubContacts.vue?vue&type=script&lang=js"
export * from "./ContactSubContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports